export default __webpack_public_path__ + "static/media/hostImgAg1.53cc4029.jpg";